// Utility to track specific page visits for onboarding completion
const VISIT_STORAGE_KEY = 'symphonytodo-page-visits';

interface PageVisits {
  settingsPage?: boolean;
  subscriptionPlan?: boolean;
}

export const trackPageVisit = {
  // Track when user visits settings page
  settings: () => {
    const visits = getPageVisits();
    visits.settingsPage = true;
    localStorage.setItem(VISIT_STORAGE_KEY, JSON.stringify(visits));
  },

  // Track when user visits subscription plan section
  subscriptionPlan: () => {
    const visits = getPageVisits();
    visits.subscriptionPlan = true;
    localStorage.setItem(VISIT_STORAGE_KEY, JSON.stringify(visits));
  }
};

export const hasVisited = {
  settingsPage: (): boolean => {
    const visits = getPageVisits();
    return visits.settingsPage === true;
  },

  subscriptionPlan: (): boolean => {
    const visits = getPageVisits();
    return visits.subscriptionPlan === true;
  }
};

function getPageVisits(): PageVisits {
  try {
    const stored = localStorage.getItem(VISIT_STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
}